import { h, JSX } from 'preact'

import { ProgressBar, ProgressBarProps } from '../../components/progress-bar/progress-bar'

export const ProgressBarSection = (props: ProgressBarProps): JSX.Element => (
    <div class="checkout__section">
        <div class="checkout__section-content">
            <ProgressBar {...props} mode="desktop" />
        </div>
    </div>
)
